import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { createCustomer, editCustomer, fetchCustomerDetail, resetCurrentCustomer, fetchCustomers, fetchFJAgents, updateFJAgents, deleteFJAgents, fetchPT, updatePT } from '../../actions/customers_actions';
import { setDefaultOfForm, changeFieldArrayOfForm } from '../../actions/purchaseOrders_actions';
import {
  fetchDefaultBuyers,
} from '../../actions/products_actions';

import CustomerForm from '../../components/Customers/customerForm';

const validate = (values) => {
  const errors = {};
  if (!values.Name) {
    errors.Name = 'Required';
  }
  if (!values.CustomerNum) {
    errors.CustomerNum = 'Required';
  }
  // if (!values.CreditLimit) {
  //     errors.CreditLimit = 'Required'
  // }
  if (!values.PriceLevel) {
    errors.PriceLevel = 'Required';
  }
  if (values.IsWholesale === null) {
    errors.IsWholesale = 'Required';
  }
  if (values.IsActive === null) {
    errors.IsActive = 'Required';
  }
  if (values.PaymentTerm_id === null || typeof (values.PaymentTerm_id) === 'undefined') {
    errors.PaymentTerm_id = 'Required';
  }

  return errors;
};


const customerForm = reduxForm({
  form: 'customerForm',
  validate,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
})(CustomerForm);

const selector = formValueSelector('customerForm');

function mapStateToProps(state) {
  const paymentTerm_id = selector(state, 'PaymentTerm_id');
  const isActive = selector(state, 'IsActive');
  const IsShowPrice = selector(state, 'IsShowPrice');
  const billing = selector(state, 'Billing');
  const mailing = selector(state, 'Mailing');
  const shipping = selector(state, 'Shipping');
  const notation = selector(state, 'Notation');
  return {
    paymentTerm_id,
    isActive,
    IsShowPrice,
    billing,
    mailing,
    shipping,
    notation,
    currentCustomer: state.customers.currentCustomer,
    currentCustomerDetail: state.customers.currentCustomerDetail,
    detailIsLoading: state.customers.detailIsLoading,
    detailError: state.customers.detailError,
    initialValues: state.customers.currentCustomerDetail,
    isCreating: state.customers.isCreating,
    createError: state.customers.createError,
    created: state.customers.created,
    isEditing: state.vendors.isEditing,
    editError: state.vendors.editError,
    edited: state.vendors.edited,

    defaultBuyers: state.products.defaultBuyers,
    defaultBuyersIsLoading: state.products.defaultBuyersIsLoading,
    defaultBuyersError: state.products.defaultBuyersError,

    paymentTerms: state.paymentTerms.all,
    paymentTermsIsLoading: state.paymentTerms.isLoading,
    paymentTermsError: state.paymentTerms.error,
    userPermissions: state.auth.userPermissions,

    customers: state.customers.all,
  };
}


export default connect(mapStateToProps, {
  fetchPaymentTerms,
  createCustomer,
  editCustomer,
  fetchCustomerDetail,
  setDefaultOfForm,
  changeFieldArrayOfForm,
  fetchDefaultBuyers,
  resetCurrentCustomer,
  fetchCustomers,
  fetchFJAgents,
  updateFJAgents,
  deleteFJAgents,
  fetchPT,
  updatePT,
})(customerForm);


// fields: ['Customer_id', 'CustomerNum', 'RefNum', 'Name', 'Description', 'Bill_CustomerContact_id',
//     'Mail_CustomerContact_id', 'Ship_CustomerContact_id', 'Bill_CustomerAddress_id', 'Mail_CustomerAddress_id',
//     'Ship_CustomerAddress_id', 'IsWholesale', 'Sales_User_id', 'PaymentTerm_id', 'CreditLimit', 'CreditStatus',
//     'PriceLevel', 'IsActive', 'DeliverPlan_id', 'IsPrtReminder', 'IsPrtGeneralInfor', 'Addresses[].Name', 'Addresses[].State',
//     'Addresses[].City', 'Addresses[].Tax_rate', 'Wholesale_ResaleNo']



// WEBPACK FOOTER //
// ./master/jsx/containers/Customers/customerForm.jsx